export default "__VITE_ASSET__CbI41xTH__"